import React from "react";
import { Col, Container, Row, Table, Badge } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import i1 from "../../../../../Assets/images/authBg.png";
import { useGetProductDetailQuery } from "../../../../../store/services/ProductStore";
import moment from "moment";

const ProductDetails = () => {
  const { id } = useParams();
  const { data: product, error, isLoading } = useGetProductDetailQuery(id);

  if (error) {
    return <div>Something went wrong</div>;
  }

  const productData = product?.data;

  return (
    <section className="userDetail py-3 position-relative">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Link
                to="/product"
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    strokeWidth="0.2"
                  />
                </svg>
              </Link>
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Product Information
              </h4>
            </div>
          </Col>
          <Col lg="12" className="my-2">
            <div
              className="formWrpper px-lg-5 p-md-4 p-3 rounded"
              style={{ background: "#EEEEEE" }}
            >
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              {!isLoading && productData && (
                <>
                  {/* Product Header */}
                  <Row className="justify-content-between">
                    <Col lg="12" className="my-2">
                      <div
                        className="imgWrp text-center mx-auto"
                        style={{ maxWidth: "max-content" }}
                      >
                        <img
                          src={productData?.flavours?.[0]?.images?.[0] || i1}
                          style={{ height: 140, width: 140 }}
                          alt=""
                          className="img-fluid rounded-circle object-fit-cover"
                        />
                      </div>
                    </Col>
                    <Col md={6} className="my-2">
                      <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-25">
                            Product Name:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {productData?.name}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-25">
                            Category:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {productData?.category?.name}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-25">
                            Serving:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {productData?.serving}
                          </h6>
                        </li>
                      </ul>
                    </Col>
                    <Col md={6} className="my-2">
                      <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-25">
                            Created At:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {moment(productData?.createdAt).format(
                              "DD/MM/YYYY"
                            )}
                          </h6>
                        </li>
                        <li className="py-3 d-flex align-items-center gap-10">
                          <p className="m-0 themeBlue fw-sbold w-25">
                            Updated At:
                          </p>
                          <h6 className="m-0 text-muted fw-bold w-50">
                            {moment(productData?.updatedAt).format(
                              "DD/MM/YYYY"
                            )}
                          </h6>
                        </li>
                      </ul>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="m-0 themeBlue fw-sbold">Description:</div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: productData?.description || "",
                        }}
                      ></p>
                      {/* <div className="m-0 text-muted">
                        {productData?.description &&
                          productData.description.replace(/<[^>]+>/g, "")}
                      </div> */}
                    </Col>
                  </Row>

                  {/* Flavours Section */}
                  {productData?.flavours?.map((flavour) => (
                    <div
                      key={flavour._id}
                      className="mt-4 p-3 rounded"
                      style={{ background: "#f8f9fa" }}
                    >
                      <Row>
                        <Col md={3} className="text-center mb-3 mb-md-0">
                          <img
                            src={flavour.images?.[0] || i1}
                            alt={flavour.name}
                            className="img-fluid rounded"
                            style={{
                              maxHeight: 120,
                              maxWidth: 120,
                              objectFit: "cover",
                            }}
                          />
                        </Col>
                        <Col md={9}>
                          <h4 className="fw-bold themeBlue">{flavour.name}</h4>
                          <div className="mb-2">{flavour.subText}</div>
                          <div className="mb-2">
                            {flavour.tags?.map((tag, i) => (
                              <Badge key={i} bg="info" className="me-1">
                                {tag}
                              </Badge>
                            ))}
                          </div>
                          <div className="mb-2">
                            <strong>Ingredients:</strong>{" "}
                            {flavour.ingredients?.join(", ")}
                          </div>
                          <div className="mb-2">
                            <strong>Allergen Info:</strong>{" "}
                            {flavour.allergenInformation &&
                              flavour.allergenInformation.replace(
                                /<[^>]+>/g,
                                ""
                              )}
                          </div>
                          <div className="mb-2">
                            <strong>Dietary Preferences:</strong>{" "}
                            {flavour.dietaryPreferences?.map((dp) => (
                              <Badge key={dp._id} bg="success" className="me-1">
                                {dp.name}
                              </Badge>
                            ))}
                          </div>
                          <div className="mb-2">
                            <strong>Stock Status:</strong>{" "}
                            {flavour.stockStatus === 1
                              ? "In Stock"
                              : "Out of Stock"}
                          </div>
                          <div className="mb-2">
                            <strong>Nutritional Info:</strong>
                            <ul className="mb-0">
                              <li>
                                Calories:{" "}
                                {flavour.nutritionalInformation?.calories}
                              </li>
                              <li>
                                Carbohydrates:{" "}
                                {flavour.nutritionalInformation?.carbohydrates}
                              </li>
                              <li>
                                Proteins:{" "}
                                {flavour.nutritionalInformation?.proteins}
                              </li>
                              <li>
                                Fats: {flavour.nutritionalInformation?.fats}
                              </li>
                            </ul>
                          </div>
                          <div className="mb-2">
                            <strong>Sizes:</strong>
                            <Table
                              striped
                              bordered
                              hover
                              responsive
                              className="mt-2"
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Discounted Price</th>
                                  <th>Image</th>
                                </tr>
                              </thead>
                              <tbody>
                                {flavour.sizes?.map((size) => (
                                  <tr key={size._id}>
                                    <td>{size.name}</td>
                                    <td>{size.quantity}</td>
                                    <td>${size.price}</td>
                                    <td>${size.discountedPrice}</td>
                                    <td>
                                      {size.images?.[0] && (
                                        <img
                                          src={size.images[0]}
                                          alt={size.name}
                                          style={{
                                            width: 40,
                                            height: 40,
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProductDetails;
